'use client';
import { Modal } from '@/components/Modal/Modal';
import PlusCircle from '@/components/icons/PlusCircle';
import { NotifsContext } from '@/contexts';
import useNavigate from '@/hooks/useNavigate';
import {
  AddEmpReq,
  FormEmployee,
  useAddEmpMutation,
  useGetListPdvQuery,
} from '@/services/API';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setUser } from '@/store/slices/recapSlice';
import { AccountStatus, ISelectNumeroAgrement, ShortPdv } from '@/types';
import { useContext, useEffect, useState } from 'react';
import Form from '../form';

export default function Page() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const selectedSte = useAppSelector((state) => state.selectedSte.societe);
  const [employee, setEmployee] = useState<FormEmployee>();
  const [pdvs, setPdvs] = useState<ISelectNumeroAgrement[]>([]);
  const [addEmp, { isLoading }] = useAddEmpMutation();
  const {
    data: pdvsSource,
    error: getListPdvsError,
    isLoading: getListPdvsLoading,
  } = useGetListPdvQuery(selectedSte.siren);
  useEffect(() => {
    if (pdvsSource) {
      let prepData: ISelectNumeroAgrement[] = pdvsSource?.map(
        ({ bnppf_pos_id, name, partner_pos_id }: ShortPdv) =>
          ({
            bnppf_pos_id,
            name,
            added: false,
            partner_pos_id,
          } as ISelectNumeroAgrement)
      );
      setPdvs(prepData);
    }
  }, [pdvsSource]);
  const { addToast } = useContext(NotifsContext);

  useEffect(() => {
    setEmployee({
      given_name: '',
      sn: '',
      email_address: '',
      mobile: '',
      federation_id: '',
      supervisor: false,
      mfa_capable: false,
      account_status: undefined,
    });
  }, []);

  const handleSendData = () => {
    if (employee) {
      let prep_seller_number_list: string[] = [];
      pdvs.map((pdv) => {
        if (pdv.added) prep_seller_number_list.push(pdv.bnppf_pos_id);
      });
      let req: AddEmpReq = {
        ...employee,
        operational_seller_number_list: prep_seller_number_list,
        employer: selectedSte.siren,
        fin_ent: 'PF', //TODO: remplacer avec valeur reel
        administrator_type: 'NA',
        administrative_seller_number_list: [],
        business_domain: 'DISTRIB',
        account_status: AccountStatus.ACTIVE,
      };

      addEmp({ siren: selectedSte.siren, reqBody: req })
        .unwrap()
        .then((payload) => {
          addToast &&
            addToast({
              toastType: 'success',
              children: 'Confirmation de création.',
            });
          dispatch(
            setUser({
              given_name: payload.given_name,
              sn: payload.sn,
              email_address: payload.email_address,
              user_password: payload.user_password,
              uid: payload.uid,
            })
          );
          navigate('recap');
        })
        .catch((err) => {
          let errorMessage = `Une erreur est survenue.
          Rééssayer ultérieurement.`;
          try {
            if (err.data[0].error === 'uniqueness') {
              errorMessage = `Ce compte existe déjà dans l'annuaire.
              Veuillez vérifier les champs uniques`;
            }
          } catch (error) {}
          addToast &&
            addToast({
              toastType: 'error',
              children: errorMessage,
            });
        })
        .finally(() => setOpenedModal(false));
    }
  };
  const [openedModal, setOpenedModal] = useState(false);

  if (getListPdvsError || getListPdvsLoading) return <></>;
  if (!employee || !pdvs) return <></>;

  return (
    <>
      <Form
        title="Nouvel employé"
        employee={employee}
        pdvs={pdvs}
        setEmployee={setEmployee}
        setPdvs={setPdvs}
        primaryBtnProps={{
          children: 'Créer un nouvel employé',
          icon: <PlusCircle />,
          variant: 'primary',
          size: 'medium',
          onClick: (e) => {
            e.preventDefault();
            setOpenedModal(true);
          },
        }}
      />
      <Modal
        primaryBtnProps={{
          loading: isLoading,
          children: 'Confirmer',
          onClick: handleSendData,
        }}
        secondaryBtnProps={{
          children: 'Annuler',
          onClick: () => setOpenedModal(false),
        }}
        title="Voulez-vous créer l'employé ?"
        open={openedModal}
        onClose={() => setOpenedModal(false)}
      />
    </>
  );
}
